import { render, staticRenderFns } from "./admin-masters.vue?vue&type=template&id=2d6b5b40&scoped=true"
import script from "./admin-masters.vue?vue&type=script&lang=js"
export * from "./admin-masters.vue?vue&type=script&lang=js"
import style0 from "./admin-masters.vue?vue&type=style&index=0&id=2d6b5b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6b5b40",
  null
  
)

export default component.exports